import React, { useEffect, useState } from "react";
import session from "../util/session";
import profiles from "../util/profiles";

const AIChatWidget = () => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const userConfigs = session.getUserConfigs();
    const userProfile = session.getUserProfile();

    if (!userConfigs) {
      setShouldRender(false);
      return;
    }

    // Verificar se é admin ou se pertence a uma das contratadas específicas
    const isAdmin = userProfile === profiles.PROFILE_SUPERUSER;

    // Converter a string de IDs em array, tratando casos de string vazia ou indefinida
    const specificContractedIds = process.env.REACT_APP_SPECIFIC_CONTRACTED_IDS_POC_IA
      ? process.env.REACT_APP_SPECIFIC_CONTRACTED_IDS_POC_IA
        .split(',')
        .map(id => parseInt(id.trim()))
        .filter(id => !isNaN(id))
      : [];

    const userContractedId = userConfigs.contractedId;

    const hasAccess = isAdmin || specificContractedIds.includes(userContractedId);

    setShouldRender(hasAccess);

    // Se tem acesso, carregar o script do chat
    if (hasAccess) {
      loadChatScript(userConfigs);
    }
  }, []);

  const loadChatScript = (userConfigs) => {
    // Verificar se o script já foi carregado
    const existingScript = document.querySelector('script[data-embed-id="df3033ef-2468-45a9-a65d-1376fb8bbe5e"]');
    if (existingScript) {
      return;
    }

    const script = document.createElement('script');
    script.setAttribute('data-embed-id', 'df3033ef-2468-45a9-a65d-1376fb8bbe5e');
    script.setAttribute('data-base-api-url', 'https://anythingllm.datalife.global/api/embed');
    script.setAttribute('data-chat-icon', 'chatBubble');
    script.setAttribute('data-brand-image-url', 'assets/img/logoDatalifeAzul.svg');
    script.setAttribute('data-assistant-icon', 'assets/img/dalia.png');
    script.setAttribute('data-username', userConfigs.id);
    script.setAttribute('data-no-sponsor', 'true');
    //script.setAttribute('data-no-header', 'false');
    script.setAttribute('data-assistant-name', 'Dália - Assistente Digital');
    script.setAttribute('data-greeting', '👷‍♂️ Olá! Envie um documento de Segurança do Trabalho e eu farei uma análise com base nas NRs aplicáveis.');
    script.setAttribute('data-reset-chat-text', 'Resetar o chat');
    script.setAttribute('data-send-message-text', 'Esclareça suas dúvidas...');
    script.setAttribute('data-support-email', 'suporte@datalife.global');
    script.setAttribute('data-button-color', '#3A67E9');
    script.setAttribute('data-language', 'pt_BR');
    script.src = 'https://anythingllm.datalife.global/embed/anythingllm-chat-widget.min.js';
    script.async = true;

    document.body.appendChild(script);

    // Cleanup function para remover o script quando o componente for desmontado
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  };

  // Só renderizar se o usuário tiver acesso
  if (!shouldRender) {
    return null;
  }

  return (
    <div id="ai-chat-widget">
      {/* O script será carregado dinamicamente e renderizará o widget aqui */}
    </div>
  );
};

export default AIChatWidget;